import {Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import {TranslationProvider} from 'i18nano';
import {BrowserRouter} from "react-router-dom";
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {HTML5Backend} from "react-dnd-html5-backend";
import {DndProvider} from "react-dnd";
import Loader from "./components/Loader";

const theme = createTheme({
    palette: {
        primary: {
            main: '#036aaa',
        }
    },
});
const translations: any = {};
let enLanguage: any;
let defaultLanguage = localStorage.getItem("lang");

const getLanguages = async () => {
    const response = await fetch(`${process.env.PUBLIC_URL}/locales/languages.json`);
    return await response.json();
}
const getEnLanguage = async () => {
    const response = await fetch(`${process.env.PUBLIC_URL}/locales/en.json`);
    return await response.json();
}
const loadLanguage = async (path: string) => {
    try {
        const response = await fetch(path);
        const data = await response.json();
        if (!enLanguage) {
            enLanguage = await getEnLanguage();
        }
        for (let property in enLanguage) {
            if (!data.hasOwnProperty(property)) {
                data[property] = enLanguage[property]
            }
        }
        return data;
    } catch {
        alert("Selected language is not supported at the moment. The web version will be switched to English");
        if (enLanguage) return enLanguage;
        return await getEnLanguage();
    }
}

getLanguages().then(async languages => {
        languages.forEach((item: any) => {
            const path = `${process.env.PUBLIC_URL}/locales/${item.code}.json`;
            translations[item.code] = () => loadLanguage(path);
        });
        if (!defaultLanguage) {
            defaultLanguage = "en";
        } else {
            if (!translations.hasOwnProperty(defaultLanguage)) {
                defaultLanguage = "en";
            }
        }

        try {
            const container = document.getElementById('root');
            const root = createRoot(container!);

            root.render(
                <BrowserRouter>
                    <DndProvider backend={HTML5Backend}>
                        <ThemeProvider theme={theme}>
                            <TranslationProvider
                                translations={translations}
                                language={defaultLanguage}
                                transition={true}>
                                <Suspense fallback={
                                    <div
                                        style={
                                            {
                                                position: "absolute",
                                                left: "50%",
                                                top: "20%",
                                                transform: "translateX(-50%)",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center"
                                            }
                                        }>
                                        <Loader/>
                                        <span>Loading language...</span>
                                    </div>}>
                                    < App/>
                                </Suspense>
                            </TranslationProvider>
                        </ThemeProvider>
                    </DndProvider>
                </BrowserRouter>
            )
        } catch (e) {
            alert(e);
        }
    }
)